export const TEXTAREA_CLASSNAMES = {
  default:
    'w-full placeholder:opacity-0 py-2 px-2.5 text-secondary border border-mediumBlue rounded-xl placeholder:text-gray1 resize-none',
  error: 'border-red text-red',
  disabled: 'bg-gray',
};
